import { createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationService } from "src/helpers/notifications";
import {
  errorResponsesTrns,
  successfulResponsesTrns,
} from "src/translate/responses";
import {
  IContacts,
  ContactUsValues,
} from "src/page-components/contact-us/types";
import { instance } from "src/services/api-client";

export const CONTACT_US_SLICE_NAME = "contact-us";

interface ISubmitContactFormParams {
  values: ContactUsValues;
  onSuccess?: VoidFunction;
}

export const submitContactFormAsync = createAsyncThunk(
  `${CONTACT_US_SLICE_NAME}/submitContactForm`,
  async (
    { values, onSuccess }: ISubmitContactFormParams,
    { rejectWithValue }
  ) => {
    try {
      await instance.post("/contact-us/", values);
      NotificationService.success(successfulResponsesTrns.contactUs);
      onSuccess?.();
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.contactUs;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);

export const getContactsAsync = createAsyncThunk(
  `${CONTACT_US_SLICE_NAME}/fetchContacts`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IContacts>("/contacts//");

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.default;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
